import Button from '../Button/Button';
import React from 'react';
import { Modal, View } from 'react-native';
import { NEUTRAL_TEXT0 } from '../../config/designSystem/Colors';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';

interface ButtonProps {
    isVisible: boolean;
    onDismiss: () => void;
    mainText: string;
    buttonText: string;
  }

export const BasicModal = ({ isVisible, onDismiss, mainText, buttonText}: ButtonProps) => {
  const {width} = useAvailableDimensions();

  const WIDTH_MODAL = 0.8*width;
  const PADDING_HORIZONTAL_MODAL = 25;
  const WIDTH_BUTTON = WIDTH_MODAL - 2*PADDING_HORIZONTAL_MODAL;
  return (
    <Modal animationType='fade' transparent={true} visible={isVisible}>
      <View style={{
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0,0,0,0.6)',
        flex:1
      }}>
        <View style={{
          backgroundColor:'white',
          borderRadius: 40,
          paddingTop: 30,
          paddingBottom:10,
          paddingHorizontal:PADDING_HORIZONTAL_MODAL,
          width:WIDTH_MODAL
        }}>
          <View style={{ justifyContent: 'center', alignItems: 'center'}}>
            <ParagraphMRegular>
              {mainText}
            </ParagraphMRegular>
          </View>
          <View style={{ justifyContent: 'space-around', alignItems: 'center', marginTop: 40 }}>
            <Button
              color={NEUTRAL_TEXT0}
              width={WIDTH_BUTTON}
              label={buttonText}
              onPress={onDismiss}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};